import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Company, Trade } from '@types'

import { PopUp } from '@components/PopUp'
import { Input } from '@components/Input'

import { SelectCompany } from '@modules/_shared/components/SelectCompany'
import { SelectTrade } from '@modules/_shared/components/SelectTrade'

import { Container } from './PopUpEditTaskTemplate.styled'
import { SelectTaskLibrary } from '../SelectTaskLibrary'
import { SequenceTaskTemplatePlanningType } from '../SequenceTemplatePlanning'

interface Props {
  task: SequenceTaskTemplatePlanningType
  onSubmit: (task: SequenceTaskTemplatePlanningType) => void
  onClose: () => void
}

export const PopUpEditTaskTemplate = (props: Props): JSX.Element => {
  const { task, onSubmit, onClose } = props

  const { t } = useTranslation()

  const { projectId } = useParams()

  const [name, setName] = useState<string>(task.name)
  const [trade, setTrade] = useState<Trade | undefined>(task.trade)
  const [company, setCompany] = useState<Company | undefined>(task.company)
  const [duration, setDuration] = useState<number>(task.duration)
  const [workforce, setWorkforce] = useState<number>(task.workforce)

  useEffect(() => {
    if (task) {
      setName(task.name)
      setTrade(task.trade)
      setCompany(task.company)
      setDuration(task.duration)
      setWorkforce(task.workforce)
    }
  }, [task])

  return (
    <PopUp
      title={t('modules_project-settings_components_PopUpEditTaskTemplate_title')}
      onSubmitLabel={t('modules_project-settings_components_PopUpEditTaskTemplate_button_edit-task')}
      onClose={onClose}
      onSubmit={() => {
        if (trade) {
          onSubmit({
            id: task.id,
            name,
            description: task.description,
            tradeKey: trade.key,
            trade,
            companyId: company?.id,
            company,
            duration,
            workforce,
            startDay: task.startDay,
            startRow: task.startRow,
          })
        }
      }}
    >
      <Container>
        <SelectTaskLibrary
          autoFocus
          required
          label={t('modules_project-settings_components_PopUpEditTaskTemplate_label_task-name')}
          placeholder={t('modules_project-settings_components_PopUpEditTaskTemplate_placeholder_task-name')}
          taskName={name}
          onChangeTask={(value, taskLibrary) => {
            setName(value)

            setDuration(taskLibrary?.duration ?? duration)
            setWorkforce(taskLibrary?.workforce ?? workforce)
          }}
        />

        <SelectTrade required trade={trade} onSelectTrade={setTrade} />

        <SelectCompany projectId={projectId || ''} company={company} onSelectCompany={setCompany} />

        <Input
          type="number"
          step={0.25}
          min={0.25}
          required
          label={t('modules_project-settings_components_PopUpEditTaskTemplate_label_duration')}
          placeholder={t('modules_project-settings_components_PopUpEditTaskTemplate_placeholder_duration')}
          value={`${duration}`}
          onChange={(v) => setDuration(parseFloat(v))}
        />
        <Input
          type="number"
          step={0.25}
          min={0}
          required
          label={t('modules_project-settings_components_PopUpEditTaskTemplate_label_workforce')}
          placeholder={t('modules_project-settings_components_PopUpEditTaskTemplate_placeholder_workforce')}
          value={`${workforce}`}
          onChange={(v) => setWorkforce(parseFloat(v))}
        />
      </Container>
    </PopUp>
  )
}
